import PropTypes from 'prop-types';

const getButtonClassName = (variant) => {
  switch (variant) {
    case 'primary':
      return 'button';
    case 'secondary':
      return 'button button--secondary';
    case 'anchor':
    default:
      return 'anchor';
  }
};

const FooterButtonContainer = ({ buttons = [], className = 'left-box' }) => (
  <div className={className}>
    {buttons.map((btn, index) => {
      const {
        id,
        label,
        onClick,
        variant = 'anchor',
        disabled = false,
        ...rest
      } = btn;

      if (!label || typeof onClick !== 'function') {
        return null;
      }

      return (
        <button
          key={id || index}
          className={getButtonClassName(variant)}
          onClick={onClick}
          disabled={disabled}
          type="button"
          {...rest}
        >
          {label}
        </button>
      );
    })}
  </div>
);

FooterButtonContainer.propTypes = {
  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      label: PropTypes.string.isRequired,
      onClick: PropTypes.func.isRequired,
      variant: PropTypes.oneOf(['anchor', 'secondary', 'primary']),
      disabled: PropTypes.bool
    })
  ),
  className: PropTypes.string
};

export default FooterButtonContainer;
